import { CollisionSystem, HistoryApi, InvalidFramePlacementSystem, ModelLoadedEventSystem, PlannerCoreApi, SelectionEventSystem, MeasurementsWidgetSystem, UnavailableProductsEventSystem, ConflictOutlineSystem, ConflictSystem, HistoryEventSystem, OutlineSelectedFrameSystem, RemoveAutoAdaptSystem } from '@inter-ikea-storageone/range';
import { AutomaticGroupBuilderSystem, FunctionalMarginSystem, FunctionalMarginValidation, OutlineSystem, RequiredConnectorsSatisfiedValidation, StandardSelectionSystem } from '@inter-ikea-core/core';
import { LadmakareProductApi } from './LadmakareProductApi';
import { LadmakareEntityApi } from './LadmakareEntityApi';
import { LadmakareSceneApi } from './LadmakareSceneApi';
import { LadmakareCameraApi } from './LadmakareCameraApi';
import { SimpleOutlineSelectedSystem } from '@inter-ikea-core/core-toolbox';
import { CompartmentPlacementValidation } from './validations/CompartmentPlacementValidation';
import { PanelSnapSystem } from './systems/PanelSnapSystem';
import { AddCabinetSystem } from './systems/AddCabinetSystem';
import { ReAddShelvesSystem } from './systems/ReAddShelvesSystem';
import { InteractableSectionSystem } from './systems/InteractableSectionSystem';
export class LadmakareCoreApi extends PlannerCoreApi {
    bootstrap(config) {
        if (!this.core) {
            throw new Error('Core not initialized yet');
        }
        // Setup core base functionality
        const { selectionService, placementService } = super.initializeBaseCoreFunctionality();
        // Register core systems
        this.registerSystem(new OutlineSystem());
        this.registerSystem(new AutomaticGroupBuilderSystem(this.core.services.entityManager));
        this.registerSystem(new SimpleOutlineSelectedSystem());
        this.registerSystem(new StandardSelectionSystem(this.core.services.entityManager, this.core.services.sceneManager));
        this.registerSystem(new FunctionalMarginSystem());
        // Register core validations
        this.registerValidation(new RequiredConnectorsSatisfiedValidation());
        this.registerValidation(new FunctionalMarginValidation(false, this.core.services.entityManager));
        const collisionValidation = this.core
            .getValidations()
            .find((validation) => validation.id === 'Collision');
        collisionValidation.enableExhaustiveValidation();
        // Setup planner APIs
        this.history = new HistoryApi(this);
        this.products = new LadmakareProductApi(this.core.services, placementService, this.reportErrorToSentry);
        this.entities = new LadmakareEntityApi(selectionService, this.core, placementService, this.ipexViewer, this.reportErrorToSentry);
        // Register planner validations
        this.registerValidation(new CompartmentPlacementValidation(this));
        // Register planner systems
        this.registerSystem(new ConflictSystem(this));
        this.registerSystem(new ConflictOutlineSystem(this));
        this.registerSystem(new HistoryEventSystem(this));
        this.registerSystem(new UnavailableProductsEventSystem(this));
        this.registerSystem(new ModelLoadedEventSystem(this));
        this.registerSystem(new InvalidFramePlacementSystem(this));
        this.registerSystem(new CollisionSystem(this, []));
        this.registerSystem(new SelectionEventSystem(this));
        this.registerSystem(new OutlineSelectedFrameSystem(this));
        this.registerSystem(new RemoveAutoAdaptSystem(this, []));
        this.registerSystem(new PanelSnapSystem(this));
        this.registerSystem(new AddCabinetSystem(this));
        this.registerSystem(new ReAddShelvesSystem(this));
        this.registerSystem(new InteractableSectionSystem(this));
        return this.loadProductCatalogs(config.productCatalogs);
    }
    getMainProductCatalog() {
        return this.catalogs['ladmakare'];
    }
    /**
     *
     * @override
     */
    async loadScene(config, setRoom) {
        // We need to wait for the scene to load before triggering the panel snap system
        // otherwise the frames will not get the correct panels
        this.getSystem('PanelSnapSystem')?.disable();
        await super.loadScene(config, setRoom);
        // When the scene has been loaded we can enable the panel snap system
        this.getSystem('PanelSnapSystem')?.enable();
    }
    initSceneApi() {
        this.scene = new LadmakareSceneApi(this.core, this.ipexViewer, this.reportErrorToSentry);
        this.registerSystem(new MeasurementsWidgetSystem(this));
    }
    initCameraApi(canvas) {
        this.camera = new LadmakareCameraApi(this.core.services.sceneManager, this.ipexViewer, this.core.services.entityManager, this, canvas);
    }
}
//# sourceMappingURL=LadmakareCoreApi.js.map